export function getAllStructurePositionNames(structure = []) {
  const seen = new Set();
  const names = [];
  (structure || []).forEach((lvl) => (lvl.positions || []).forEach((p) => {
    const name = (p.roleName || "").trim();
    if (name && !seen.has(name)) {
      seen.add(name);
      names.push(name);
    }
  }));
  return names;
}

export function normalizePositionKey(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[\u2013\u2014]/g, "-")
    .replace(/\s+/g, " ")
    .replace(/\s*-\s*/g, " - ");
}

function expandPositionAbbreviations(value) {
  return String(value || "")
    .replace(/\bSr\.?\b/gi, "Senior")
    .replace(/\bJr\.?\b/gi, "Junior")
    .replace(/\bAVP\b/gi, "Associate Vice President")
    .replace(/\bVP\b/gi, "Vice President")
    .replace(/\bMgr\.?\b/gi, "Manager");
}

export function resolvePositionInput(input, structure = []) {
  const raw = String(input || "").trim();
  if (!raw) return { matched: true, value: "" };

  const canonicalNames = getAllStructurePositionNames(structure);
  if (!canonicalNames.length) return { matched: true, value: raw };

  const inputVariants = [
    normalizePositionKey(raw),
    normalizePositionKey(expandPositionAbbreviations(raw)),
  ];

  for (const name of canonicalNames) {
    const nameVariants = [
      normalizePositionKey(name),
      normalizePositionKey(expandPositionAbbreviations(name)),
    ];
    if (inputVariants.some((inputKey) => nameVariants.some((nameKey) => inputKey === nameKey))) {
      return { matched: true, value: name };
    }
  }

  return { matched: false, value: raw };
}
